import { ColorEnum } from '@/constants/color'
import Typography from '@/features/ui/typography'
import { ComponentProps, FC } from 'react'
import { View, ViewProps } from 'react-native'
import { UnistylesVariants, createStyleSheet, useStyles } from 'react-native-unistyles'

type TextSize = ComponentProps<typeof Typography.Description>['size']

type OrderBadgeProps = ViewProps &
    UnistylesVariants<typeof stylesheet> & {
        textSize?: TextSize
    }

const OrderBadge: FC<OrderBadgeProps> = ({
    children,
    size = 'normal',
    textSize,
    style,
    ...props
}) => {
    const { styles } = useStyles(stylesheet, { size })

    return (
        <View {...props} style={[styles.container, style]}>
            <Typography.Description size={textSize ?? size} font="bold">
                {children}
            </Typography.Description>
        </View>
    )
}

const stylesheet = createStyleSheet({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: ColorEnum.YELLOW_400,
        variants: {
            size: {
                large: {
                    borderRadius: 8,
                    minWidth: 40,
                    minHeight: 68,
                    paddingHorizontal: 10,
                    alignSelf: 'stretch',
                },
                normal: {
                    borderRadius: 8,
                    height: 40,
                    minWidth: 40,
                    paddingHorizontal: 10,
                },
                small: {
                    borderRadius: 4,
                    height: 16,
                    minWidth: 16,
                    paddingHorizontal: 4,
                },
            },
        },
    },
})

export default OrderBadge
